const Order = {
  order_id: "",
  division_id: "",
  customer_PO: "",
  ERP_order_id: "",
  store_grp: "",
  schema_id: "",
  spec_instr: "",
  vendor_notes: "",
  sp_Code: "",
  printer_notes: "",
  user_id: "",
  priority_id: -1,
  requestDate: "",
  orderedBy: "",
  spCode: "",
  key1: "",
  key2: "",
  key3: "",
  checkIfOrdered: false,
  checkProcessStatus: false,
  Web_order_id: "",
  Order_Status: "",
  wastageType: "",
  StoreCustomEvent: "",
  loaRequested: false,
  catID: -1,
  createdDate: "",
  xmlKeys: "",
  // collect_order: false,
  collect_order: "",
  customer_id: "",
  catalogueEntryGuid: "",
  add_hold_data: false,
  on_hold: "Y",
  on_hold_reason: "",
  wasCatBlocked: false,
  SkipOrderConfirmation: false,
  saveKitData: false,
  carrier_code: "",
  shipping_instructions: "",
  order_line_instructions: "",
  freight_term: "",
  rbo_pono: "",
  customer_request_date: "2022-11-10",
  promise_date: "2022-11-11",
  customer_order_date: "2022-10-20T00:00:00",
  ship_mark: "",
  collector_name: "",
  ordersource: "",
  CopyOrderId: "",
  VIPSVarOrderHeaderItem: [],
  VIPSOrderDetailItem: [],
};

export default Order;
